import { compare } from "@/utils/common";
import { replaceCdnAddress } from "@/utils/common";
export default {
  data() {
    return {
      isAlbumsLoading: false,
      isFileLoading: false,
      isImagesLoading: false
    };
  },
  computed: {
    localeColumns() {
      return this.$store.getters.localeColumns;
    }
  },
  methods: {
    buildFormByVgcData(vgcItem) {
      let form = this.buildForm();
      let currentSeriesId = [26, 28, 20, 2];
      // 26 2.0系列
      // 28 612系列
      // 20 麻石四代
      // 2 麻石一代
      form.name.cn = vgcItem.nameCn;
      form.name.en = vgcItem.nameEn;
      form.series_ids = [
        currentSeriesId.includes(vgcItem.seriesId) ? vgcItem.seriesId : 28
      ];
      form.code = vgcItem.code;
      form.colorId = vgcItem.colorId;
      form.introduction.cn = vgcItem.introduction || "";
      form.introduction.en = vgcItem.introduction || "";
      form.description.cn = vgcItem.description || "";
      form.description.en = vgcItem.description || "";
      form.oneline_description.cn = vgcItem.onelineDescription || "";
      form.oneline_description.en = vgcItem.onelineDescription || "";
      form.poster_image_url = replaceCdnAddress(vgcItem.poster_image_url);
      form.poster_slogan.cn = vgcItem.posterSlogan || "";
      form.poster_slogan.en = vgcItem.posterSlogan || "";
      form.cover_image_url = replaceCdnAddress(vgcItem.cover_image_url);
      form.rendering_image_url = replaceCdnAddress(vgcItem.renderingImageUrl);
      form.thumbnail_url = replaceCdnAddress(vgcItem.thumbnailUrl);
      form.normal_medias = vgcItem.medias.map(elData => {
        return {
          cover_image_url: replaceCdnAddress(elData.cover_image_url),
          seq: elData.seq,
          type_id: elData.typeId,
          url: replaceCdnAddress(elData.url)
        };
      });
      form.element_medias = vgcItem.elementMedias.map(elData => {
        return {
          cover_image_url: replaceCdnAddress(elData.cover_image_url),
          seq: elData.seq,
          type_id: elData.typeId,
          url: replaceCdnAddress(elData.url)
        };
      });
      form.photos = vgcItem.photos.map(elData => {
        return {
          cover_image_url: replaceCdnAddress(elData.cover_image_url),
          seq: elData.seq,
          type_id: elData.typeId,
          url: replaceCdnAddress(elData.url)
        };
      });
      form.albums = form.element_medias.map(data => {
        return {
          name: {
            cn: vgcItem.nameCn,
            en: vgcItem.nameEn
          },
          url: data.url,
          seq: data.seq
        };
      });
      form.files = form.element_medias.map(data => {
        return {
          name: {
            cn: vgcItem.nameCn,
            en: vgcItem.nameEn
          },
          url: data.url,
          seq: data.seq
        };
      });
      form.vgc_product_id = vgcItem.id;
      form.seq = 1;
      return form;
    },
    buildForm() {
      return {
        name: { ...this.localeColumns },
        series_ids: [],
        code: null,
        colorId: null,
        introduction: { ...this.localeColumns },
        description: { ...this.localeColumns },
        oneline_description: { ...this.localeColumns },
        poster_slogan: { ...this.localeColumns },
        poster_image_url: "",
        cover_image_url: "",
        rendering_image_url: "",
        thumbnail_url: "",
        normal_medias: [
          // {
          //   cover_image_url: "",
          //   seq: this.form.normalMedias.length,
          //   type_id: type,
          //   url: "",
          // }
        ],
        element_medias: [
          // {
          //   cover_image_url: "",
          //   seq: this.form.elementMedias.length,
          //   type_id: type,
          //   url: "",
          // }
        ],
        photos: [
          // {
          //   cover_image_url: "",
          //   seq: this.form.photos.length,
          //   type_id: type,
          //   url: "",
          // }
        ],
        albums: [
          // {
          //   name: {
          //     cn: '',
          //     en: '',
          //   },
          //   url: '',
          //   seq: 1,
          // }
        ],
        files: [
          // {
          //   name: {
          //     cn: '',
          //     en: '',
          //   },
          //   url: "",
          //   seq: 1,
          // }
        ],
        vgc_product_id: null,
        seq: 0
      };
    },
    handleSeriesClear() {
      this.refreshSeriesOptions();
    },
    // 元素图
    addElementMedias(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.element_medias.length,
        type_id: type,
        url: ""
      };
      this.form.element_medias.push(item);
    },
    removeElementMedias(index) {
      this.form.element_medias.splice(index, 1);
    },
    clearElementMediasVideoCover(index) {
      this.form.element_medias = this.form.element_medias.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    // 实拍图
    addPhotos(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.photos.length,
        type_id: type,
        url: ""
      };
      this.form.photos.push(item);
    },
    removePhotos(index) {
      this.form.photos.splice(index, 1);
    },
    clearPhotosVideoCover(index) {
      this.form.photos = this.form.photos.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    // normalMedias媒体
    addMedias(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.normal_medias.length,
        type_id: type,
        url: ""
      };
      this.form.normal_medias.push(item);
    },
    removeMedias(index) {
      this.form.normal_medias.splice(index, 1);
    },

    clearMediaVideoCover(index) {
      this.form.normal_medias = this.form.normal_medias.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    // 画册操作
    handleAlbumsBeforeUpload(file) {
      let allowType = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowType.includes(file.type)) {
        this.$message.error(`上传的图片格式不合法,格式需要为jpeg/jpg/png`);
        return false;
      }
      this.isAlbumsLoading = true;
      return true;
    },
    handleAlbumsSuccess(response, file) {
      this.form.albums.push({
        name: {
          cn: file.name,
          en: file.name
        },
        url: file.response.data ? file.response.data : "",
        seq: this.form.albums.length + 1
      });
      this.isAlbumsLoading = false;
      this.$message.success(`文件${file.name}上传成功`);
    },
    handleAlbumsError(err, file) {
      console.error(err);
      this.$message.error(`文件${file.name}上传失败`);
      this.isAlbumsLoading = false;
    },
    handleRemoveAlbums(index) {
      this.form.albums.splice(index, 1);
    },

    // 文件
    handleFilesBeforeUpload() {
      this.isFileLoading = true;
      return true;
    },
    handleFilesSuccess(response, file) {
      this.form.files.push({
        name: {
          cn: file.name,
          en: file.name
        },
        url: file.response.data ? file.response.data : "",
        seq: this.form.files.length + 1
      });
      this.isFileLoading = false;
      this.$message.success(`文件${file.name}上传成功`);
    },
    handleFilesError(err, file) {
      console.error(err);
      this.$message.error(`文件${file.name}上传失败`);
      this.isFileLoading = false;
    },
    handleRemoveFiles(index) {
      this.form.files.splice(index, 1);
    },

    // 工具
    bulidMediaItem() {
      return {
        url: "",
        type_id: "",
        cover_image_url: "",
        seq: 0
      };
    },
    bulidSourceItem() {
      return {
        name: { ...this.localeColumns },
        url: "",
        seq: 0
      };
    },
    buildI18nKeyValue(data) {
      if (data && Object.keys(data).length > 0) {
        let _data = { ...data };
        if (_data.i18n) {
          delete _data.i18n;
          return _data;
        }
        return _data;
      }
      return this.localeColumns;
    },
    sortArr(data = []) {
      if (data.length <= 0) {
        return data;
      }
      return data.sort(compare("seq"));
    },
    formatArrData(data = []) {
      if (data.length <= 0) {
        return [];
      }
      return data
        .filter(item => {
          return item.url !== "";
        })
        .map((item, index) => {
          item.seq = index;
          return item;
        });
    },
    formatDataToids(data = []) {
      if (data.length <= 0) {
        return data;
      }
      return data.map(item => item.id);
    }
  }
};
